import { RadioListItemType } from '@screens/Category/ui/Filter/RadioListItem/RadioListItem';

export function getRanges(start: number, end: number, minMax?: number[]): RadioListItemType[] {
  const ranges: RadioListItemType[] = [];

  // Проверяем что start и end >= 0
  if (start < 0 || end < 0) {
    return ranges;
  }

  if (start > end) {
    return ranges;
  }

  // Корректируем start: если start < 50, то устанавливаем в 50
  const adjustedStart = start < 50 ? 50 : start;

  // Округляем откорректированный start вниз до ближайшего десятка
  const startRange = Math.floor(adjustedStart / 10) * 10;

  // Округляем end вверх до ближайшего десятка
  const endRange = Math.ceil(end / 10) * 10;

  // Если startRange < 50, то начинаем с 50
  const actualStartRange = Math.max(startRange, 50);

  // Добавляем специальный диапазон 0-50, если start был меньше 50
  if (start < 50) {
    ranges.push({
      id: `0-50-${endRange}`,
      min: start,
      max: 50,
      active: minMax?.[0] === start && minMax?.[1] === 50
    });
  }

  // Добавляем остальные диапазоны с шагом 10, начиная с actualStartRange
  for (let i = actualStartRange; i < endRange; i += 10) {
    const max = i + 10;

    ranges.push({
      id: `${actualStartRange}-${i}-${endRange}`,
      min: i,
      max: max,
      active: minMax?.[0] === i && minMax?.[1] === max
    });
  }

  return ranges;
}
